import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Onboarding from 'components/molecules/onboarding';
import { hasCookie } from 'services/actions/cookies_actions';
import createTrack from 'services/actions/tracker_actions';
import { cleanCnpj, maskCnpj, validateCnpj } from 'utils/cnpj';
import { Container } from './styles';

const ConcurrentsNew = () => {
  const history = useHistory();
  const [cnpj, setCnpj] = useState<string>('');

  useEffect(() => {
    document.title = 'Concorrentes - ConLicitação';
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCnpj(maskCnpj(event.target.value));
  };

  const handleSearch = () => {
    if (!cnpj.trim()) return;

    const unmasked = cleanCnpj(cnpj);
    if (!validateCnpj(cnpj)) {
      alert('Digite um CNPJ válido.');
      return;
    }

    createTrack('Concorrentes - Consultou Sanções');

    history.push(`/concorrente/${unmasked}`);
  };

  return (
    <Container>
      <div className="page-container">
        <div className="container">
          <h1 className="mb-3">Análise de concorrentes</h1>
          <p className="mb-4">
            Pesquise o CNPJ do seu concorrente e tenha acesso aos demonstrativos de participações
            por período, com foco em vitórias homologadas e derrotas em licitações públicas.
          </p>
          <div className="tour-concurrents-begin d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">
            <input
              type="text"
              className="form-control"
              placeholder="Digite o CNPJ"
              aria-label="Campo para digitar o CNPJ do concorrente"
              value={cnpj}
              onChange={handleChange}
              style={{ maxWidth: '300px' }}
            />
            <button type="button" className="btn btn-primary" onClick={handleSearch}>
              Buscar
            </button>
          </div>
        </div>
      </div>
      {!hasCookie('tourConcurrentsBegin') && <Onboarding tourSelect="tourConcurrentsBegin" />}
    </Container>
  );
};

export { ConcurrentsNew };
